/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';

/**
 *
 * @export
 * @interface PerturbedVoiceAgentDataset
 */
export interface PerturbedVoiceAgentDataset {
  /**
   *
   * @type {number}
   * @memberof PerturbedVoiceAgentDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedVoiceAgentDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedVoiceAgentDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedVoiceAgentDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedVoiceAgentDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {number}
   * @memberof PerturbedVoiceAgentDataset
   */
  stateSchema?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedVoiceAgentDataset
   */
  evaluateState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedVoiceAgentDataset
   */
  hasState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedVoiceAgentDataset
   */
  hasTokenUsage?: boolean;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof PerturbedVoiceAgentDataset
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {Array<number>}
   * @memberof PerturbedVoiceAgentDataset
   */
  audioRecordings?: Array<number>;
}

/**
 * Check if a given object implements the PerturbedVoiceAgentDataset interface.
 */
export function instanceOfPerturbedVoiceAgentDataset(value: object): value is PerturbedVoiceAgentDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function PerturbedVoiceAgentDatasetFromJSON(json: any): PerturbedVoiceAgentDataset {
  return PerturbedVoiceAgentDatasetFromJSONTyped(json, false);
}

export function PerturbedVoiceAgentDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedVoiceAgentDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    stateSchema: json['state_schema'] == null ? undefined : json['state_schema'],
    evaluateState: json['evaluate_state'] == null ? undefined : json['evaluate_state'],
    hasState: json['has_state'] == null ? undefined : json['has_state'],
    hasTokenUsage: json['has_token_usage'] == null ? undefined : json['has_token_usage'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    audioRecordings: json['audio_recordings'] == null ? undefined : json['audio_recordings'],
  };
}

export function PerturbedVoiceAgentDatasetToJSON(
  value?: Omit<PerturbedVoiceAgentDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    state_schema: value['stateSchema'],
    evaluate_state: value['evaluateState'],
    has_state: value['hasState'],
    has_token_usage: value['hasTokenUsage'],
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    audio_recordings: value['audioRecordings'],
  };
}
